const styles = {
  tab: {
    width: {
      xs: '50%',
      sm: 'inherit',
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      position: 'relative',
      transform: 'none',
      ml: 1,
    },
  },
}

export default styles
